import type { ReactNode } from 'react';
import { Badge, Button, Divider, Group, Modal, Stack, Text, TextInput } from '@mantine/core';
import { ErrorAlert } from '@/components/error-alert';

type CrmOverrideModalProps = {
  typeLabel: string;
  isExisting: boolean;
  name: string;
  onNameChange: (name: string) => void;
  error: string | null;
  isSaving: boolean;
  canSave: boolean;
  onSave: () => void;
  onClose: () => void;
  children: ReactNode;
};

export function CrmOverrideModal({
  typeLabel,
  isExisting,
  name,
  onNameChange,
  error,
  isSaving,
  canSave,
  onSave,
  onClose,
  children,
}: CrmOverrideModalProps) {
  return (
    <Modal
      opened
      onClose={onClose}
      size="lg"
      title={
        <Group gap="sm">
          <Text fw={500}>{isExisting ? 'Edit CRM Override' : 'Create CRM Override'}</Text>
          <Badge variant="light" size="sm">
            {typeLabel}
          </Badge>
        </Group>
      }
    >
      <Stack gap="md">
        <ErrorAlert message={error} />
        <TextInput label="Integration Name" value={name} onChange={(e) => onNameChange(e.currentTarget.value)} />

        {children}

        <Divider />

        <Group justify="flex-end">
          <Button variant="subtle" onClick={onClose}>
            Cancel
          </Button>
          <Button onClick={onSave} loading={isSaving} disabled={!name.trim() || !canSave}>
            {isExisting ? 'Save Override' : 'Create Override'}
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
}
